import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

// Settings > Modules > All Modules (top tab id 5, section id 1).
const MODULES_SETTINGS_URL = "/settings/5/1";

// Friendly full-page state shown when a feature's SystemModule is switched off.
// Used by ModuleGate to replace gated routes. `moduleName` is the human label,
// `description` overrides the default blurb if a page wants something specific.
const ModuleNotActive = ({
  moduleName = "This module",
  description,
  icon = "ri-toggle-line",
}) => {
  return (
    <div className="page-content">
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ minHeight: "60vh", padding: "2rem" }}
      >
        <div
          className="d-flex align-items-center justify-content-center mb-4"
          style={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            background: "rgba(99, 102, 241, 0.12)",
            color: "#6366f1",
          }}
        >
          <i className={icon} style={{ fontSize: "2.75rem" }} />
        </div>

        <h3 className="mb-2">{moduleName} is not active</h3>

        <p className="text-muted mb-4" style={{ maxWidth: 520 }}>
          {description ||
            `The ${moduleName} module is currently switched off for your company. Turn it on in Settings to start using this feature.`}
        </p>

        <Button
          component={Link}
          to={MODULES_SETTINGS_URL}
          variant="contained"
          startIcon={<i className="ri-settings-3-line" />}
          sx={{ textTransform: "none", fontWeight: 700, borderRadius: "10px" }}
        >
          Go to Module Settings
        </Button>
      </div>
    </div>
  );
};

export default ModuleNotActive;
